module.exports = __webpack_public_path__ + "static/media/NaviBlue.1595ada2.svg";